// extracted by mini-css-extract-plugin
module.exports = {"companies":"bedrijven-module--companies--UKyUi","companyTile":"bedrijven-module--companyTile--2qFvw"};